(() => {
  const MIN_QTY_FOR_CHECKOUT = 3;

  const bindThreshold = ({
    root,
    inputSelector,
    buttonSelector,
    observeTargetSelector,
    bindKey,
  }) => {
    if (!root) return;

    const bindingNode = root instanceof Element ? root : document.documentElement;
    const bindingFlag = bindKey || 'default';
    const boundKeys = (bindingNode.dataset.checkoutThresholdBound || '').split(',').filter(Boolean);
    if (boundKeys.includes(bindingFlag)) return;
    boundKeys.push(bindingFlag);
    bindingNode.dataset.checkoutThresholdBound = boundKeys.join(',');

    const getCheckoutButton = () => root.querySelector(buttonSelector);

    const getBottleMultiplier = (variantTitle) => {
      const vt = (variantTitle || '').toLowerCase();
      if (vt.includes('half case')) return 3;
      if (vt.includes('case (6)') || vt.includes('case of 6')) return 6;
      const parenMatch = vt.match(/\((\d+)\)/);
      if (parenMatch) return Number(parenMatch[1]) || 1;
      return 1;
    };

    const hasUnblockItem = () => {
      const rootEl = root instanceof Element ? root : document.documentElement;
      return rootEl.querySelector('.cart-item[data-unblock="true"]') !== null;
    };

    const getTotalBottleCount = () => {
      const quantityInputs = root.querySelectorAll(inputSelector);
      return Array.from(quantityInputs).reduce((total, input) => {
        const qty = Number.parseInt(input.value, 10) || 0;
        const cartItem = input.closest('.cart-item') || input.closest('li');
        const variantEl = cartItem && cartItem.querySelector('.cart-item__variant');
        const variantTitle = variantEl ? variantEl.textContent.trim() : '';
        return total + (qty * getBottleMultiplier(variantTitle));
      }, 0);
    };

    const updateCheckoutState = () => {
      const checkoutButton = getCheckoutButton();
      if (!checkoutButton) return;

      const defaultLabel = checkoutButton.dataset.defaultLabel || 'Checkout';
      const threshold = Number(checkoutButton.dataset.threshold) || MIN_QTY_FOR_CHECKOUT;

      if (hasUnblockItem()) {
        checkoutButton.disabled = false;
        checkoutButton.setAttribute('aria-disabled', 'false');
        checkoutButton.textContent = defaultLabel;
        return;
      }

      const bottleCount = getTotalBottleCount();
      const shouldDisable = bottleCount < threshold;

      checkoutButton.disabled = shouldDisable;
      checkoutButton.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');

      if (shouldDisable) {
        const needed = threshold - bottleCount;
        checkoutButton.textContent = `${bottleCount}/${threshold} added — please add ${needed} more`;
      } else {
        checkoutButton.textContent = defaultLabel;
      }
    };

    const scheduleUpdate = () => {
      window.requestAnimationFrame(updateCheckoutState);
    };

    const observeTarget = root.querySelector(observeTargetSelector);
    if (observeTarget) {
      const observer = new MutationObserver(scheduleUpdate);
      observer.observe(observeTarget, { childList: true, subtree: true });
    }

    updateCheckoutState();
  };

  const init = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      bindThreshold({
        root: cartDrawer,
        inputSelector: '#cart-drawer-main quantity-spinner .js-quantity-spinner-input',
        buttonSelector: '#cart-drawer-checkout button[name="checkout"]',
        observeTargetSelector: '#cart-drawer-main',
        bindKey: 'drawer',
      });
    }

    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      bindThreshold({
        root: document,
        inputSelector: '#main-cart-items quantity-spinner .js-quantity-spinner-input',
        buttonSelector: '#cart-checkout button[name="checkout"]',
        observeTargetSelector: '#main-cart-items',
        bindKey: 'cartpage',
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('product:stitcher:section-replaced', init);
})();